// extracted by mini-css-extract-plugin
export var accept = "CookieBanner-module--accept--97d2d";
export var banner = "CookieBanner-module--banner--86676";
export var link = "CookieBanner-module--link--c2405";
export var text = "CookieBanner-module--text--d11ce";